export const StoreActionType:any = {
    SET_CURRENT_USER              : "SET_CURRENT_USER",
    SET_DARK_MODE                 : "SET_DARK_MODE",
    SET_LEFTMENU_OPEN             : "SET_LEFTMENU_OPEN",
    SET_COUNTRY                   :  "SET_COUNTRY",
    SET_REGION                    :  "SET_REGION",
    SET_CONTENT                   :  "SET_CONTENT",
    SET_MENU_CONTENT              :  "SET_MENU_CONTENT",
    SET_MENU_OPEN                 :  "SET_MENU_OPEN",
    GET_RETURN_DETAILS_REQUEST    : 'GET_RETURN_DETAILS_REQUEST',
    GET_RETURN_DETAILS_SUCCESS    : 'GET_RETURN_DETAILS_SUCCESS',
    GET_RETURN_DETAILS_FAILURE    : 'GET_RETURN_DETAILS_FAILURE',
    GET_ORDER_DETAILS_REQUEST     : 'GET_ORDER_DETAILS_REQUEST',
    GET_ORDER_DETAILS_SUCCESS     : 'GET_ORDER_DETAILS_SUCCESS',
    GET_ORDER_DETAILS_FAILURE     : 'GET_ORDER_DETAILS_FAILURE',
    SET_CHECK_OPERATOR_INFO       : "SET_CHECK_OPERATOR_INFO",
    GET_CAMPAIGN_MATRIX_REQUEST   : 'GET_CAMPAIGN_MATRIX_REQUEST',
    GET_CAMPAIGN_MATRIX_SUCCESS   : 'GET_CAMPAIGN_MATRIX_SUCCESS',
    GET_CAMPAIGN_MATRIX_FAILURE   : 'GET_CAMPAIGN_MATRIX_FAILURE',
    SET_CAMPAIGN_MATRIX_CAMPAIGN_FILTER  : 'SET_CAMPAIGN_MATRIX_CAMPAIGN_FILTER',
    SET_CAMPAIGN_LIVE_CAMPAIGN_FILTER   : 'SET_CAMPAIGN_LIVE_CAMPAIGN_FILTER',
    GET_CAMPAIGN_LOG_ACTIVITIES_REQUEST : "GET_CAMPAIGN_LOG_ACTIVITIES_REQUEST",
    GET_CAMPAIGN_LOG_ACTIVITIES_SUCCESS : "GET_CAMPAIGN_LOG_ACTIVITIES_SUCCESS",
    GET_CAMPAIGN_LOG_ACTIVITIES_FAILURE : "GET_CAMPAIGN_LOG_ACTIVITIES_FAILURE",
    SET_CAMPAIGN_LOG_FILTER             : "SET_CAMPAIGN_LOG_FILTER",
    SHOW_SNACKBAR                      : "SHOW_SNACKBAR",
    HIDE_SNACKBAR                      : "HIDE_SNACKBAR",
    SET_LAST_REGION                     : "SET_LAST_REGION",
    SET_NAVIGATE_URLS            : "SET_NAVIGATE_URLS"
};